import React from "react";

import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import { Card, Grid, Stack, Typography, useTheme } from "@mui/material";

import { EmptyState } from "src/shell/components/EmptyState";
import { getCardStyles } from "src/shell/styles/themeUtils";

const AIOpsTab: React.FC = () => {
  const theme = useTheme();
  const sections = [
    "Health overview",
    "Anomalies detected",
    "Predictions",
    "Cost optimization",
    "Deployment impact analysis",
    "Recent incidents",
  ];

  return (
    <Stack spacing={2}>
      <Card sx={getCardStyles(theme)}>
        <Typography variant="h6" fontWeight={700}>
          AIOps
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Organization health and operational intelligence will appear here when
          the AIOps data service is available.
        </Typography>
      </Card>
      <Grid container spacing={2}>
        {sections.map((section) => (
          <Grid
            item
            xs={12}
            md={section === "Health overview" ? 12 : 6}
            key={section}
          >
            <Card sx={getCardStyles(theme)}>
              <Typography variant="subtitle1" fontWeight={700}>
                {section}
              </Typography>
              <EmptyState
                icon={AutoGraphIcon}
                title="Data unavailable"
                subtitle="This section will populate from an organization-scoped AIOps data source."
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};

export default AIOpsTab;
